import React from 'react';
import {Badge} from "antd";
import {Link} from "react-router-dom";

import LoadingSpinner from "../../../components/LoadingSpinner";
import ErrorBanner from "../../../components/ErrorBanner";
import {useAuth} from "../../../providers/AuthProvider";


const JobsPanel = ({isLoading, error, refetch, stats, disabled, disabledReason}) => {
    const daysSinceUpdated = 5
    const {auth} = useAuth();

    // total_approved_teams
    // total_available_teams
    // total_contracts
    // total_invited_talent_opps
    // total_matching_open_positions
    // total_new_contracts
    // total_new_invited_talent_opps
    // total_new_matching_open_positions
    // total_new_open_positions
    // total_open_positions
    // total_prospect_talent_opps
    // total_teams
    const jobBoardType = auth?.canManageClientResourceTalent?.() ? 'supplier' : 'talent';

    const jobBoardPath = `/${jobBoardType}/job-board`;



    return (
        <div className="flex-1 w-full mb-6 sm:px-3 md:w-5/12 xl:w-4/12">
            <div className={TB.mapClass("talent-dashboard-panel", {disabled})}>

                <div className="header-content">
                    <div>
                        <Badge count={parseInt(0) || 0}>
                            <h1 className="dashboard-title">
                                Jobs
                            </h1>
                        </Badge>

                        {!disabled && (
                            <div className="header-last-updated static -mt-1.5">
                                <p className={daysSinceUpdated > 30 ? 'text-danger' : ''}>
                                    <i className="fas fa-clock"/>
                                    &nbsp; {`${daysSinceUpdated} day${(daysSinceUpdated === 1) ? '' : 's'} ago`}
                                </p>
                            </div>
                        )}
                    </div>

                    {!disabled && (
                        <Link to={jobBoardPath} className="btn btn-primary ml-auto self-center">
                            View Jobs
                        </Link>
                    )}
                </div>

                {!disabled ? (
                    <div className="talent-panel-content-container">

                        {(!isLoading && !error && stats) ? (
                            <div className="talent-panel-section pt-6">
                                <div className="talent-panel-content">
                                    <div className="talent-job-panel-links">
                                        <p>Check out available work:</p>

                                        <div className="inline">
                                            <span>
                                                <Link
                                                    to={{pathname: jobBoardPath}}
                                                    state={{only_matching: 0}}
                                                    className="inline btn btn-link btn-link-primary"
                                                >
                                                    {stats?.total_open_positions}
                                                </Link> jobs.
                                            </span>
                                            &nbsp;
                                            <span>
                                                <Link
                                                    to={{pathname: jobBoardPath}}
                                                    state={{only_matching: 1}}
                                                    className="inline btn btn-link btn-link-primary"
                                                >
                                                    {stats.total_matching_open_positions}
                                                </Link> matches.
                                            </span>
                                            &nbsp;
                                            <span>
                                                <Link
                                                    to={jobBoardPath}
                                                    className="inline btn btn-link btn-link-primary"
                                                >
                                                    {stats.total_new_matching_open_positions}
                                                </Link> new
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="flex-grow items-center justify-center flex flex-col">
                                {isLoading ? <LoadingSpinner size={'lg'}/> : (
                                    error && <ErrorBanner onRetry={refetch}/>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                   <React.Fragment>
                       <div className="corner">
                           <span>Not Available Yet!</span>
                       </div>
                       <p className={"message"}>
                           {disabledReason}
                       </p>
                   </React.Fragment>
                )}
            </div>
        </div>
    )
}

export default JobsPanel;